import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetSeatingEntitlementQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetSeatingEntitlementQuery = { __typename?: 'Query'; seatingEntitlement: { __typename?: 'SeatingEntitlement'; hasSeatingPlus: boolean } };

export const GetSeatingEntitlementDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSeatingEntitlement' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seatingEntitlement' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasSeatingPlus' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSeatingEntitlementQuery__
 *
 * To run a query within a React component, call `useGetSeatingEntitlementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeatingEntitlementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeatingEntitlementQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetSeatingEntitlementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSeatingEntitlementQuery, GetSeatingEntitlementQueryVariables>) {
  return ApolloReactHooks.useQuery<GetSeatingEntitlementQuery, GetSeatingEntitlementQueryVariables>(GetSeatingEntitlementDocument, baseOptions);
}
export function useGetSeatingEntitlementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSeatingEntitlementQuery, GetSeatingEntitlementQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetSeatingEntitlementQuery, GetSeatingEntitlementQueryVariables>(GetSeatingEntitlementDocument, baseOptions);
}
export type GetSeatingEntitlementQueryHookResult = ReturnType<typeof useGetSeatingEntitlementQuery>;
export type GetSeatingEntitlementLazyQueryHookResult = ReturnType<typeof useGetSeatingEntitlementLazyQuery>;
export type GetSeatingEntitlementQueryResult = Apollo.QueryResult<GetSeatingEntitlementQuery, GetSeatingEntitlementQueryVariables>;
